import React, { FC } from 'react';
import Image from 'next/image';
import { Product } from '~/src/components/blocks/referral-products/products/components/product-list/components/product/product';
import { BriefcaseIcon } from '~/src/components/svg-components/briefcase-icon';
import { ClientsFormEnum } from '~/src/models/enums/clients-form.enum';
import { MTS_INTERNET } from '~/src/models/constants/product-codes';
import { IMAGE_QUALITY } from '~/src/models/constants/image-quality.constants';
import type { ProductsDictionaryMappedInterface } from '~/src/repositories/cms/types/cms.types';
import type { FormVariant } from '~/src/context/client-request-form/client-request-form.types';
import type { ChangeCheckboxHandlerType } from '~/src/models/types/change-checkbox-handler.types';
import * as Styled from './product-list.styles';

interface ProductListProps {
    dataProducts: [string, ProductsDictionaryMappedInterface[]][];
    onChangeCheckbox: ChangeCheckboxHandlerType;
    width?: string;
    onMouseOverTooltip: (id: number) => void;
    currentId: number;
    checkedProductCodes: string[];
    changeCheckedProductCodes: React.Dispatch<React.SetStateAction<string[]>>;
    currentVariant: FormVariant;
}

export const ProductList: FC<ProductListProps> = ({
    dataProducts,
    width,
    onChangeCheckbox,
    currentId,
    onMouseOverTooltip,
    checkedProductCodes,
    currentVariant,
}) => {
    return (
        <Styled.CheckboxesMainContainer width={width}>
            {dataProducts.map(([group, data], index) => {
                if (!data?.length || !group) {
                    return null;
                }

                const groupIcon = data[0].smallGroupImage;

                return (
                    <Styled.CheckboxesGroupContainer key={index + group}>
                        <Styled.GroupTitleContainer>
                            {groupIcon ? (
                                <Image
                                    src={groupIcon}
                                    alt="Иконка группы продуктов"
                                    width={24}
                                    height={24}
                                    quality={IMAGE_QUALITY.VERY_HIGH}
                                    unoptimized
                                />
                            ) : (
                                <BriefcaseIcon />
                            )}
                            <Styled.TitleGroup>{group}</Styled.TitleGroup>
                        </Styled.GroupTitleContainer>

                        <Styled.CheckboxesContainer>
                            {data.map((elem) => (
                                <Product
                                    key={index + group + elem?.code}
                                    code={elem?.code || ''}
                                    name={elem?.name || ''}
                                    content={String(elem?.content || '')}
                                    tooltipIsHovered={Number(elem?.id) === currentId}
                                    onChange={(isChecked) => {
                                        onChangeCheckbox(elem.addressRequired, isChecked, elem?.name, elem?.code);
                                    }}
                                    disabled={
                                        currentVariant === ClientsFormEnum.FORM_SELF_EMPLOYED &&
                                        elem.code !== MTS_INTERNET
                                    }
                                    onMouseOverTooltip={() => elem?.id && onMouseOverTooltip(elem?.id)}
                                    checkedOnStart={checkedProductCodes.includes(elem?.code)}
                                />
                            ))}
                        </Styled.CheckboxesContainer>
                    </Styled.CheckboxesGroupContainer>
                );
            })}
        </Styled.CheckboxesMainContainer>
    );
};
